import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class BadgeService {
  metricPrefixes: string[] = ["", "k", "M", "G", "T", "P", "E", "Z", "Y", "R", "Q"];
  /**
   * @returns correct badge value.
   * Any value over 1000 will be adjusted
   * 1.0k, 1.5k, etc.
   */
  badgeValue = (value: number | string): string => {
    if (value === undefined) {
      return "0";
    }

    if (typeof value === "string") {
      value = Number(value);
    }

    // Determines what SI prefix to use
    const tier = (Math.log10(Math.abs(value)) / 3) | 0;

    // if zero, return
    if (tier == 0) {
      return value.toString();
    }

    // get suffix and determine scale
    const suffix = this.metricPrefixes[tier] ?? "";
    const scale = Math.pow(10, tier * 3);

    // scale the number
    const scaled = value / scale;

    // format number and add suffix
    return `${scaled.toFixed(1).trim()}${suffix?.trim() ?? ""}`;
  };
}
